import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from "lodash";
import { authHeader } from '../../helpers';
import { parseWindowsOS } from '../../helpers';
import format from 'date-fns/format';
import api from '../../constants/api';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Pagination from '@material-ui/lab/Pagination';
import Paper from '@material-ui/core/Paper';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Dialog from "material-ui/Dialog";
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Button } from '@material-ui/core';
import BreadCrumbNav from '../BreadCrumbNav'
import { getUser,getUserSort,getComparator,stableSort,getFilterOptions } from '../../helpers';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { postApi } from '../../helpers/http';

import './Terminal.css'

const regex = /[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|\u203B/g;
const kCanEditRole = [false, true, true, true];
const kStatusName = ["利用中", "保管", "廃棄"];

class Terminal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      limit: 100,
      date: null,
      user_name: null,
      user_id : null,
      section_name: null,
      section_id : null,
      department_name: null,
      department_id : null,
      pc_name: null,
      mac_add : null,
      checkedFilter: true,
      i_num: 0,
      inputMemo: '',
      confirmDialog: false,
      checkedChange: false,
      selectedData: {},
      // filtered_status: {},
      order: "asc", 
      orderBy: "systemNo",
      firstLoad: true, 
      chatOpened: false,
    };
    this.debouncedFetchData = _.debounce(this.fetchData);
  }
  componentDidMount() {
    // 詳細データリストを取得
    this.fetchData();
  }

  //サビースタグのサポート表示のURLを作成する関数
  functionUrlCreate = (strSereial = "") => {
      return "https://www.dell.com/support/home/en-vn/product-support/servicetag/" + strSereial + "/overview";
  }

  // 詳細データリストを取得
  fetchData = () => {
    const { getTerminals } = this.props;
    const params = {
      user_name: this.state.user_name,
      pc_name: this.state.pc_name,
      section_name: this.state.section_name,
      department_name: this.state.department_name,
      user_id : this.state.user_id,
      section_id : this.state.section_id,
      department_id : this.state.department_id,
      mac_add : this.state.mac_add,
      blnDiscardShow:!this.state.checkedFilter,
      date: format(Date.now(), 'yyyy-MM-dd')
    };
    getTerminals(params);
  }

  handleClickDownloadCSV = (filteredItems) =>{
    const csvRows = ["検索条件："];  
    if (this.state.user_name === null) {
      csvRows.push("　ユーザー名: すべて");
    } else if (this.state.user_name === "") {
      csvRows.push("　ユーザー名: 空白");
    } else {
      csvRows.push("　ユーザー名: " + this.state.user_name);
    };

    if (this.state.section_name === null) {
      csvRows.push("　部: すべて");
    } else if (this.state.section_name === "") {
      csvRows.push("　部: 空白");
    } else {
      csvRows.push("　部: " + this.state.section_name);
    };

    if (this.state.department_name === null) {
      csvRows.push("　課: すべて");
    } else if (this.state.department_name === "") {
      csvRows.push("　課: 空白");
    } else {
      csvRows.push("　課: " + this.state.department_name);
    };

    if (this.state.pc_name === null) {
      csvRows.push("　端末番号: すべて");
    } else if (this.state.pc_name === "") {
      csvRows.push("　端末番号: 空白");
    } else {
      csvRows.push("　端末番号: " + this.state.pc_name);
    };

    const csvHeaderTitles = ["管理番号", "端末番号", "状態", "コメント", "ユーザー名", "型番", "モデル名", "シリアルNo", "CPU情報", "メモリ", "OS", "使用期間", "利用年数"];
    csvRows.push([csvHeaderTitles.join(',')]);
  
    filteredItems.forEach(item => {
      const row = [
       
        `\t${item.systemNo}`, 
        item.pc_name,
        kStatusName[item.statusKb||0], 
        item.memo || '', 
        item.user_name,
        item.manufacturer,
        item.system_model,
        item.serial_number,
        item.cpu_info,
        `\t${Number(item.mem_installed).toFixed(2)}`,
        item.os_name || parseWindowsOS(item.os_info),
        item.used_Period,
        item.used_yearCount === null || item.used_yearCount === "" || item.used_yearCount.includes('0000/00/00') ? '不明' : item.used_yearCount,
      ];
      csvRows.push(row.map(v => `"${v.toString().replace(/"/g, '""')}"`).join(','));
    });
  
    const csvData = csvRows.join('\n');
    const BOM = '\uFEFF';
    const blob = new Blob([BOM + csvData], { type: 'text/csv;charset=utf-8;' });

    const date = new Date();
    const options = {
      timeZone: "Asia/Tokyo",
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    };

    const formattedDate = new Intl.DateTimeFormat('ja-JP', options).format(date).replace(/\D/g, ''); 
    const filename = `管理番号一覧_${formattedDate}.csv`;

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
  
  changePagination = (event, newPage) => {
    const newOffset = newPage - 1;
    this.setState({
      offset: newOffset
    });
  };

  render() {
    const user = getUser();
    const {items, isFetching} = this.props
    const filteredItems = items
      ? ( stableSort(items.detailData || [], getComparator(this.state.order, this.state.orderBy))
        ).filter( (item) =>{
          return ( 
          ( this.state.user_name === null ? true : this.state.user_name === "" ? item.user_name === "" 
            : this.state.user_id !== null ? item.user_id === this.state.user_id
            : item.user_name && item.user_name.includes(this.state.user_name)
          ) &&

          ( this.state.department_name === null ? true : this.state.department_name === "" ? item.department_name === "" 
            : this.state.department_id !== null ? item.department_id === this.state.department_id
            : item.department_name && item.department_name.includes(this.state.department_name)
          ) &&

          ( this.state.section_name === null ? true : this.state.section_name === "" ? item.section_name === "" 
            : this.state.section_id !== null ? item.section_id === this.state.section_id
            : item.section_name && item.section_name.includes(this.state.section_name)
          ) &&

          // ( this.state.pc_name === null ? true : this.state.pc_name === "" ? item.pc_name === "" 
          //   : this.state.mac_add !== null ? item.mac_add === this.state.mac_add
          //   : item.pc_name && item.pc_name.includes(this.state.pc_name)
          // ) &&

          ( this.state.pc_name === null ? true : this.state.pc_name === "" ? item.pc_name === "" 
            : item.pc_name && item.pc_name.includes(this.state.pc_name)
          ) &&

          // (this.state.department_id === null || (this.state.department_id === item.department_id)) &&
          // (this.state.section_id === null || (this.state.section_id === item.section_id)) &&
          // (this.state.mac_add === null || (this.state.mac_add === item.mac_add)) &&
          // (this.state.section_name === null || (this.state.section_name === "" ) || (this.state.section_name !== "" && item.section_name.includes(this.state.section_name) )) &&
          // (this.state.department_name === null || (this.state.department_name === "") || (this.state.department_name !== "" && item.department_name.includes(this.state.department_name) )) &&
          // (this.state.pc_name === null || (this.state.pc_name === "") || (this.state.pc_name !== "" && item.pc_name.includes(this.state.pc_name) )) &&
          (this.state.checkedFilter === false || item.statusKb !== 2)
          )
          }
      )
    : [];

    // フィルターデータ設定
    let user_options,department_options,section_options,pc_spec_options;
    if (filteredItems.length >0){
    // if (items && items.detailData && items.detailData.length > 0) {
      user_options=getFilterOptions(filteredItems,["user_id","user_name"],"user_name","user_name")
                  .sort((a, b) => a.user_name.localeCompare(b.user_name, undefined, {sensitivity: "base", numeric: true}));

      section_options=getFilterOptions(filteredItems,["section_id","section_name"],"section_name","section_name")
                  .sort((a, b) => a.section_name.localeCompare(b.section_name, undefined, {sensitivity: "base", numeric: true}));

      department_options=getFilterOptions(filteredItems,["department_id","department_name"],"department_name","department_name")
                  .sort((a, b) => a.department_name.localeCompare(b.department_name, undefined, {sensitivity: "base", numeric: true}));

      pc_spec_options=getFilterOptions(filteredItems,["mac_add","pc_name"],"pc_name","pc_name")
                  .sort((a, b) => a.pc_name.localeCompare(b.pc_name, undefined, {sensitivity: "base", numeric: true}));
    }
    
    // const displayedItems = filteredItems.slice(offset * limit, (offset + 1) * limit);
    const displayedItems = filteredItems.slice(this.state.offset * this.state.limit, (this.state.offset + 1) * this.state.limit);

    // const toLowerCase = (text) => {
    //   return text ? text.toLowerCase() : '';
    // } 
    
    // this.state.filtered_status = (items.detailData || []).filter(item => this.state.checkedFilter === false || item.statusKb !== 2);
    // this.setState({filtered_status:(items.detailData || []).filter(item => this.state.checkedFilter === false || item.statusKb !== 2)});

    const handleClickOpenConfirmDialog = (event) => {
      const { value, name } = event.target;
      this.setState({selectedData: {statusKb: value, systemNo: name}, confirmDialog: true});
    };

    const handleCloseConfirmDialog = () => {
      this.setState({selectedData: {}, confirmDialog: false, checkedChange: false});
    };

    // 端末状態変更処理
    const changeStatus = async (event) => {
      const { statusKb, systemNo } = this.state.selectedData;
      const Index = _.findIndex(items.detailData, function(o) { return o.systemNo === systemNo; });
      const mac_add = items.detailData[Index].mac_add;
      const savedStatusKb = items.detailData[Index].statusKb;
      items.detailData[Index].statusKb = statusKb;
      this.forceUpdate();
      handleCloseConfirmDialog();

      const data = {
        "process_type": "updateStatusKb",
        "mac_add": mac_add,
        "statusKb": statusKb,
      };

      try {
        const json = await postApi(data);
        items.detailData[Index].used_Period = json.data.used_Period;
        this.forceUpdate();
      } catch (error) {
        items.detailData[Index].statusKb = savedStatusKb;
        this.forceUpdate();
        console.error('Error:', error);
      };
  
      // const requestOptions = {
      //     method: 'POST',
      //     headers: authHeader(),
      //     body: JSON.stringify(data),
      // };
      // fetch(api.url, requestOptions)
      //     .then(response => response.json())
      //     .then(json => {
      //       // console.log(json);
      //       items.detailData[Index].used_Period = json.data.used_Period;
      //       this.forceUpdate();
      //     })
      //     .catch((error) => {
      //       items.detailData[Index].statusKb = savedStatusKb;
      //       this.forceUpdate();
      //       console.error('Error:', error);
      //     });
    };

    // const changeChatWindow = (event) => {
    //   this.setState({chatOpened: !this.state.chatOpened});
    // }

    //「廃棄端末を表示しない」状態変更時
    const handleChangeStatusFilter = (event) => {
      const { changeFilterDatas } = this.props
      this.setState({ ...this.state, [event.target.name]: event.target.checked });
      changeFilterDatas({[event.target.name]: event.target.checked});
    };

    // フィルターデータ変更時の処理
    const handleChangeFilter = (filterDict) => {
      // const { changeFilterDatas } = this.props
      this.setState({ ...this.state,firstLoad: false,...filterDict});
      // changeFilterDatas({...filterDict});
    };

    const handleClickEdit = (event, systemNo, memo) => {
      event.preventDefault();
      // console.log("handleClickEdit", systemNo);
      this.setState({ i_num: systemNo });
      this.setState({ inputMemo: memo });
    };

    // メモ更新処理
    const keyDown = async (event) => {
      if (event.key === 'Enter') {
        const Index = _.findIndex(items.detailData, function(o) { return o.systemNo === event.target.name; });
        const mac_add = items.detailData[Index].mac_add;
        const memo = items.detailData[Index].memo;
        items.detailData[Index].memo = event.target.value;
        // this.forceUpdate();
        this.setState({ i_num: -1});

        const data = {
          "process_type": "updateMemo",
          "mac_add": mac_add,
          "memo": event.target.value,
        };

        try {
          const json = await postApi(data);
        } catch (error) {
          items.detailData[Index].memo = memo;
          this.forceUpdate();
          console.error('Error:', error);
        };
    
        // const requestOptions = {
        //     method: 'POST',
        //     headers: authHeader(),
        //     body: JSON.stringify(data),
        // };
        // fetch(api.url, requestOptions)
        //     .then(response => response.json())
        //     .then(json => {
        //       // console.log(json);
        //     })
        //     .catch((error) => {
        //       items.detailData[Index].memo = memo;
        //       this.forceUpdate();
        //       console.error('Error:', error);
        //     });
      }
    };

    // データソート
    const createSortHandler = (property) => (event) => {
      const isAsc = this.state.orderBy === property && this.state.order === 'asc';
      const order = {order: isAsc ? 'desc' : 'asc'};
      this.setState(order);

      const orderBy = {orderBy: property};
      this.setState({
        ...order,
        ...orderBy,
        i_num: -1,
        firstLoad: false,
      });
      localStorage.setItem('setting-user-sort', JSON.stringify({...order, ...orderBy}));
    };

    // // フィルターコンボボックスのデータ取得
    // function getFilterOptions(items,keys,uniqItem,sortbyItem){
    //   if (items.length===0){return [];}
    //   let options= _.map(items,item => _.pick(item,keys));
    //   options=_.uniqBy(options, uniqItem);
    //   options=_.sortBy(options,sortbyItem);
    //   return options;
    // };

    return (
      <div className="content-container">
        
        {this.state.firstLoad && isFetching ? <div className='loading'>お待ちください．．．</div>
          :<>
          <BreadCrumbNav screenName="管理番号一覧"></BreadCrumbNav>
          <div className="table-loginname">ログイン名：{user.username}</div>

          <div className="filter-container">
            <FormControl className="formterminal-filter">
              <Autocomplete
                freeSolo
                id="combo-box-autocomplete-user_name"
                className="combo-box-autocomplete-terminal"
                value={this.state.user_name}
                onChange={(event, newValue) => {
                  if (!newValue) {
                    handleChangeFilter({
                      user_name: null,
                      user_id: null,
                      firstLoad: false,
                      offset: 0
                    });
                  } else {
                    handleChangeFilter({
                      user_id: newValue.user_id ?? null,
                      user_name: newValue.user_name ?? "",
                      firstLoad: false,
                      offset: 0
                    });
                  }
                }}
                onInputChange={(event, value) => {
                  if (event && event.type === "change") {
                    handleChangeFilter({user_name:value,user_id:null,firstLoad: false , offset: 0 });
                  }
                }}
                options={
                  this.state.user_name && this.state.user_name.trim() !== "" && user_options
                    ? user_options.filter(item => item.user_name.toLowerCase().includes(this.state.user_name.toLowerCase()))
                    : user_options || []
                }
                getOptionLabel={(option) => 
                  typeof option === 'string' ? option : option?.user_name || ''
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="autocomplete-filter"
                    label="ユーザー名："
                    variant="outlined"
                    fullWidth
                  />
                )}
              />
            </FormControl>

            <FormControl className="formterminal-filter">
              <Autocomplete
               freeSolo
               id="combo-box-autocomplete-section_name"
               className="combo-box-autocomplete-terminal"
               value={this.state.section_name}
              //  onChange={(event, newValue) => {
              //     handleChangeFilter({section_id:newValue&&newValue.section_id?newValue.section_id:null,section_name: newValue&&newValue.section_name?newValue.section_name:"",firstLoad: false , offset: 0});
              // }}
               onChange={(event, newValue) => {
                  if (!newValue) {
                    handleChangeFilter({
                      section_name: null,
                      section_id: null,
                      firstLoad: false,
                      offset: 0
                    });
                  } else {
                    handleChangeFilter({
                      section_id: newValue.section_id ?? null,
                      section_name: newValue.section_name ?? "",
                      firstLoad: false,
                      offset: 0
                    });
                  }
                }}
              onInputChange={(event, value) => {
                if (event && event.type === "change") {
                  handleChangeFilter({section_name:value,section_id:null,firstLoad: false , offset: 0});
                  }
              }}
              options={
                this.state.section_name && this.state.section_name.trim() !== "" && section_options
                  ? section_options.filter(item => item.section_name.toLowerCase().includes(this.state.section_name.toLowerCase()))
                  : section_options || []
              }
              getOptionLabel={(option) => 
                typeof option === 'string' ? option : option?.section_name || ''
              }
              renderInput={(params) => (
                 <TextField
                  {...params}
                  className="autocomplete-filter"
                  label="部："
                  variant="outlined"
                  fullWidth
                  />
                )}
                />
            </FormControl>

            <FormControl className="formterminal-filter">
              <Autocomplete
               freeSolo
               id="combo-box-autocomplete-department_name"
               className="combo-box-autocomplete-terminal"
               value={this.state.department_name}
              //  onChange={(event, newValue) => {
              //     handleChangeFilter({department_id:newValue&&newValue.department_id?newValue.department_id:null,department_name: newValue&&newValue.department_name?newValue.department_name:"", firstLoad: false , offset: 0});
              // }}
              onChange={(event, newValue) => {
                  if (!newValue) {
                    handleChangeFilter({
                      department_name: null,
                      department_id: null,
                      firstLoad: false,
                      offset: 0
                    });
                  } else {
                    handleChangeFilter({
                      department_id: newValue.department_id ?? null,
                      department_name: newValue.department_name ?? "",
                      firstLoad: false,
                      offset: 0
                    });
                  }
                }}
              onInputChange={(event, value) => {
                if (event && event.type === "change") {
                  handleChangeFilter({department_name:value,department_id:null,firstLoad: false , offset: 0 });
                }
              }}

              options={
                this.state.department_name && this.state.department_name.trim() !== "" && department_options
                  ? department_options.filter(item => item.department_name.toLowerCase().includes(this.state.department_name.toLowerCase()))
                  : department_options || []
              }

              getOptionLabel={(option) => 
                 typeof option === 'string' ? option : option?.department_name || ''
              }
              renderInput={(params) => (
                 <TextField
                  {...params}
                  className="autocomplete-filter"
                  label="課："
                  variant="outlined"
                  fullWidth
                  />
              )}
              />
            </FormControl>
            
            <FormControl className="formterminal-filter">
              <Autocomplete
               freeSolo
               id="combo-box-autocomplete-pc_name"
               className="combo-box-autocomplete-terminal"
               value={this.state.pc_name}
              //  onChange={(event, newValue) => {
              //     handleChangeFilter({mac_add:newValue&&newValue.mac_add?newValue.mac_add:null,pc_name: newValue&&newValue.pc_name?newValue.pc_name:"", firstLoad: false , offset: 0});
              // }}
              onChange={(event, newValue) => {
                if (!newValue) {
                  handleChangeFilter({
                    pc_name: null,
                    mac_add: null,
                    firstLoad: false,
                    offset: 0
                  });
                } else {
                  handleChangeFilter({
                    mac_add: newValue.mac_add ?? null,
                    pc_name: newValue.pc_name ?? "",
                    firstLoad: false,
                    offset: 0
                  });
                }
              }}
              onInputChange={(event, value) => {
                if (event && event.type === "change") {
                  handleChangeFilter({pc_name:value,mac_add:null, firstLoad: false , offset: 0});
                }
              }}
              options={
                this.state.pc_name && this.state.pc_name.trim() !== "" && pc_spec_options
                  ? pc_spec_options.filter(item => item.pc_name.toLowerCase().includes(this.state.pc_name.toLowerCase()))
                  : pc_spec_options || []
              }
              getOptionLabel={(option) => 
                 typeof option === 'string' ? option : option?.pc_name || ''
              }
              renderInput={(params) => (
              <TextField
                {...params}
                className="autocomplete-filter"
                label="端末番号："
                variant="outlined"
                fullWidth
              />
              )}
            />
            </FormControl>

            <FormControlLabel className="terminal-filter"
              control={<Checkbox checked={this.state.checkedFilter} onChange={handleChangeStatusFilter} name="checkedFilter" />}
              label="廃棄端末を表示しない"
            />

            <FormControl className="terminal-download">
              <Button
                variant="contained"
                color="primary"
                className="download-button"
                onClick={() => this.handleClickDownloadCSV(filteredItems)}
                disabled={!this.props.items || this.props.items.length === 0}
              >
                ダウンロード
              </Button>
            </FormControl>

            <div className='terminal-item-count'>
              <b>検索結果：{filteredItems.length}件</b>
            </div>

          </div>

          <Paper className="table-root">
            <TableContainer className="terminal-table-container">
              <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      <TableCell 
                      key="systemNo"
                      align="center" 
                      sortDirection={this.state.orderBy === "systemNo" ? this.state.order : false}
                      style={{ minWidth: 120 }}
                      >              
                        <TableSortLabel
                          //active={this.state.orderBy === "systemNo"}
                          direction={this.state.orderBy === "systemNo" ? this.state.order : 'asc'}
                          onClick={createSortHandler("systemNo")}
                        >
                          管理番号
                          {this.state.orderBy === "systemNo" ? (
                            <span className="visuallyHidden">
                              {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                            ) : null}
                        </TableSortLabel>  
                        
                        </TableCell>
                      <TableCell 
                      key="pc_name"
                      align="center" 
                      sortDirection={this.state.orderBy === "pc_name" ? this.state.order : false}
                      style={{ minWidth: 120 }}
                      >
                        <TableSortLabel
                          //active={this.state.orderBy === "pc_name"}
                          direction={this.state.orderBy === "pc_name" ? this.state.order : 'asc'}
                          onClick={createSortHandler("pc_name")}
                        >
                          端末番号
                          {this.state.orderBy === "pc_name" ? (
                            <span className="visuallyHidden">
                              {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                            ) : null}
                        </TableSortLabel>
                        </TableCell>
                      <TableCell align="center" style={{ minWidth: 110 }}>状態</TableCell>
                      <TableCell align="center" style={{ minWidth: 200 }}>コメント</TableCell>
                      <TableCell 
                      key="user_name"
                      align="center" 
                      sortDirection={this.state.orderBy === "user_name" ? this.state.order : false}
                      style={{ minWidth: 160 }}
                      >
                        <TableSortLabel
                          //active={this.state.orderBy === "user_name"}
                          direction={this.state.orderBy === "user_name" ? this.state.order : 'asc'}
                          onClick={createSortHandler("user_name")}
                        >
                          ユーザー名
                          {this.state.orderBy === "user_name" ? (
                            <span className="visuallyHidden">
                              {this.state.order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </span>
                            ) : null}
                        </TableSortLabel>                    
                        </TableCell>
                      <TableCell colSpan={3} align="center" style={{ minWidth: 370 }}>PC情報<br/>型番 ・ モデル名 ・ シリアルNo.</TableCell>
                      <TableCell align="center" style={{ minWidth: 350 }}>CPU</TableCell>
                      <TableCell align="center" style={{ minWidth: 100 }}>メモリ</TableCell>
                      <TableCell align="center" style={{ minWidth: 170 }}>OS</TableCell>
                      <TableCell align="center" style={{ minWidth: 100 }}>使用期間</TableCell>
                      <TableCell align="center" style={{ minWidth: 100 }}>利用年数</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {displayedItems.map((item) => (
                      <TableRow key={item.systemNo} className={`${item.statusKb === 2 && "termial-junk"}`}>
                        <TableCell align="center" component="th" scope="row">{item.systemNo}</TableCell>
                        <TableCell align="center">{item.pc_name}</TableCell>
                        <TableCell align="center">
                          <FormControl variant="outlined" className="table-status">
                            <Select
                              name={item.systemNo}
                              mac_add={item.mac_add}
                              value={item.statusKb||0}
                              onChange={handleClickOpenConfirmDialog}
                              disabled={!kCanEditRole[user.role]}
                            >
                              <MenuItem value={2}>{kStatusName[2]}</MenuItem>
                              <MenuItem value={1}>{kStatusName[1]}</MenuItem>
                              <MenuItem value={0}>{kStatusName[0]}</MenuItem>
                            </Select>
                          </FormControl>
                        </TableCell>
                        <TableCell align="center">
                            {(this.state.i_num === item.systemNo && kCanEditRole[user.role]) ? (
                              <TextField autoFocus style={{ width: "100%" }}
                                name={item.systemNo}
                                mac_add={item.mac_add}
                                value={this.state.inputMemo}
                                onChange={e => this.setState({ inputMemo: e.target.value })}
                                onKeyDown={keyDown}
                                onBlur={e => {
                                  // console.log("lost focus");
                                  this.setState({ i_num: -1 });
                                }}
                              />
                            ) : (
                              <div style={{ width: "100%", minHeight: "32px", height: "auto" }} id={item.systemNo} onClick={e => handleClickEdit(e, item.systemNo, item.memo)}>{item.memo}</div>
                            )}
                          </TableCell>
                        <TableCell align="center">{item.user_name}</TableCell>
                        <TableCell align="center">{item.manufacturer}</TableCell>
                        <TableCell align="center">{item.system_model}</TableCell>
                        {(item.manufacturer.includes("Dell Inc.")&&regex.test(item.serial_number)===false&&item.serial_number.length===7) ?
                            <TableCell align="center">
                              <a href={this.functionUrlCreate(item.serial_number)} target="_blank" rel="noopener noreferrer">
                                {item.serial_number}
                              </a>
                            </TableCell> :
                            <TableCell align="center">{item.serial_number}</TableCell>
                        }
                        <TableCell align="center">{item.cpu_info}</TableCell>
                        <TableCell align="center">{Number(item.mem_installed).toFixed(2)}</TableCell>
                        <TableCell align="center">{item.os_name === "" ? parseWindowsOS(item.os_info) : item.os_name}</TableCell>
                        <TableCell align="center">{item.used_Period}</TableCell>
                        <TableCell align="center">{item.used_yearCount === null || item.used_yearCount === "" || item.used_yearCount.includes('0000/00/00') ? '不明' : item.used_yearCount}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
              </Table>
            </TableContainer>
            { filteredItems.length > 0 && 
              <div className='pagination-button'>
                <Pagination
                  page={this.state.offset + 1}
                  count={Math.ceil(filteredItems.length / this.state.limit)}
                  onChange={this.changePagination}
                  color="primary"
                  variant="outlined"
                  shape="rounded"
                  showFirstButton
                  showLastButton
                />
              </div>
            }
          </Paper>
          </>
        }
        <Dialog
          open={this.state.confirmDialog}
          onRequestClose={handleCloseConfirmDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"変更確認"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {`${kStatusName[this.state.selectedData.statusKb]}に状態を変更しますか？`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={changeStatus} color="primary">
              はい
            </Button>
            <Button onClick={handleCloseConfirmDialog} color="primary" autoFocus>
              いいえ
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

Terminal.propTypes = {
  getTerminals: PropTypes.func.isRequired,
  changeFilterDatas: PropTypes.func.isRequired,
};

export default Terminal;